import { IHubService } from "../../domain/IHubService";

const GetHubKeyByLocalIdUseCase = async (service: IHubService, localId: string) => {
    const response = await service.getHubByLocalId(localId);    
    return response
}
export default GetHubKeyByLocalIdUseCase
